import { DataProvider } from 'react-admin'
import { IksorisParkingTicketCashMachineDto } from '../../dto/device/ticket-machines/iksoris-parking-ticket-cash-machine/iksoris-parking-ticket-cash-machine.dto'

const fakeFiles: IksorisParkingTicketCashMachineDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
